
import { mapGetters } from "vuex";

export default {
  name: "StatusConexao",

  computed: {
    ...mapGetters("alertas", ["STATUS_CONEXAO"]),
  },
};
